// File: src/App.js
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero.jsx';
import WhatsAppButton from './components/WhatsAppButton';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DataDeletion from './pages/DataDeletion';
import Footer from './components/Footer';

function HomePage({ language }) {
  return (
    <>
      <Hero language={language} />
      {/* Future sections: BlogPreview, Testimonials, Contact, etc. */}
      <WhatsAppButton />
    </>
  );
}

function App() {
  const [language, setLanguage] = useState('nl');

  return (
    <Router>
      <div className="font-sans pt-16 min-h-screen flex flex-col justify-between">
        <Navbar language={language} />
        <main className="flex-grow">
          <header className="flex justify-end p-4">
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="border border-gray-300 rounded px-2 py-1"
            >
              <option value="en">EN</option>
              <option value="fr">FR</option>
              <option value="nl">NL</option>
            </select>
          </header>
          <Routes>
            <Route path="/" element={<HomePage language={language} />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/datadeletion" element={<DataDeletion />} />
          </Routes>
        </main>
        <Footer language={language} />
      </div>
    </Router>
  );
}

export default App;

